/*
 * Copyright 2024 GLA UK Research and Development Directive
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * The BaseApiUrlInterceptor Component.
 */
@Injectable()
export class BaseApiUrlInterceptor implements HttpInterceptor {

    /**
     * The BaseApiUrl Interceptor Component Constructor.
     */
    constructor(@Inject('BASE_API_URL') private baseApiUrl: string) {

    }

    /**
     * The interceptor actual functionality.
     * 
     * This is where the API request is actually intercepted and the base API
     * URL is appended as a prefix.
     * 
     * @param request   the outgoing request
     * @param next      the next response
     * @returns the HTTP handler result
     */
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const apiReq = request.clone({ url: `${this.baseApiUrl.replace(/\/$/, '')}${request.url}` });
        return next.handle(apiReq);
    }

}
